import React, { useState } from "react";
import fetchData from "../../api/fetchApi";

import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";


export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetchData("login", 
       "POST",
       JSON.stringify({ username: email, password }),
      );
      if (res.status !== 200) {
        throw new Error(res.message || "فشل تسجيل الدخول");
      }
      localStorage.setItem("access_token", res.tokens.access_token);
      localStorage.setItem("refresh_token", res.tokens.refresh_token);
      localStorage.setItem("token", res.tokens.access_token);
      localStorage.setItem("user", email );
      localStorage.setItem("role",  res.role || "user");
      await new Promise((resolve) => setTimeout(resolve, 1000));
      // window.location.href = "/#/admin/dashboard";

      window.open("/#/admin/dashboard", "_blank");
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء تسجيل الدخول");
    } finally {
      setLoading(false);
    }
  };

  return (
    // make layout stack on small screens and be side-by-side on md+
    <div className="flex flex-col md:flex-row w-full min-h-screen bg-gray-50">
      <div className="hidden md:flex w-1/2 items-center justify-center bg-gray-50 ">
        <img
          src={'../../login_bg.png'}
          alt="App Preview"
          className="w-full h-full object-cover "
        />
      </div>
      {/* Left / Form column */}
      <div className="w-full md:w-1/2 bg-white flex flex-col items-center justify-center py-8">
        {/* Mobile top banner image */}
        <div className="w-full md:hidden pb-4 px-4">
          <img src={
'phone'
          } alt="Preview" className="w-full h-40 object-cover rounded-2xl" />
        </div>

        <div className="relative z-10 bg-white rounded-3xl shadow-2xl max-w-md w-full p-6 md:p-8 mx-4 md:mx-auto overflow-hidden" dir="rtl">
          <div className="flex justify-center my-6">
            <img src={logo} alt="Logo" className="h-20" />
          </div>
          <h2 className="text-2xl font-bold mb-2 text-center text-gray-800">مرحبا بك في شبكة التشريعات الليبية</h2>
          <p className="text-center text-gray-500 mb-6">مجتمع متكامل للقانون ومصادر موثوقة كل هذا في مكان واحد</p>

          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <label className="block mb-1 font-medium text-right">البريد الإلكتروني</label>
              <input
                // type="email"
                className="w-full border rounded-md px-3 py-2 text-right focus:outline-none focus:ring-2 focus:ring-blue-200"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
                placeholder="أدخل بريدك الإلكتروني"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-right">كلمة السر</label>
              <div className="relative">
                <input
                  type="password"
                  className="w-full border rounded-md px-3 py-2 text-right focus:outline-none focus:ring-2 focus:ring-blue-200"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  placeholder="********"
                />
                <span className="absolute left-3 top-1/2 -translate-y-1/2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </span>
              </div>
            </div>

            <div className="flex items-center justify-between">
                <div className="flex items-center">
                <label htmlFor="remember" className="ml-2 text-sm text-gray-600">تذكرني</label>
                <input
                  type="checkbox"
                  id="remember"
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
              </div>
              <Link to="/auth/forgot-password" className="text-sm text-gray-600 hover:underline hover:text-[var(--Primary-Primary)] transition-colors duration-100">
                هل نسيت كلمة السر؟
              </Link>
              
            </div>

            {error && <div className="text-red-600 text-center">{error}</div>}
            <button
              type="submit"
              className="w-full text-black py-3 rounded-md border border-gray-300 hover:bg-[var(--Primary-Primary)] hover:text-white transition-colors duration-300 font-semibold"
              disabled={loading}
            >
              {loading ? "جاري التسجيل..." : "تسجيل الدخول"}
            </button>
          </form>
        </div>
      </div>

      {/* Right / Preview image on md+ */}
      
    </div>
  );
}